import { useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import avatar from '../images/profile.png';
// import profile from '../images/mubisir.png';
// import { MdOutlinePublishedWithChanges } from 'react-icons/md';
import { SlDocs } from 'react-icons/sl';
import { Button, Modal } from 'react-bootstrap';
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import ProfileImage from '../images/markImg.png';

// import namecircle from "../images/name-circle.png";

function MainHome() {
	const [show, setShow] = useState(false);

	const resumebtn = () => {
		setShow(true);
	};

	const resumeDownload = () => {
		// using Java Script method to get PDF file
		fetch('Muhammad-Mubashir-AK-Resume.pdf').then((response) => {
			response.blob().then((blob) => {
				// Creating new object of PDF file
				const fileURL = window.URL.createObjectURL(blob);
				// Setting various property values
				let alink = document.createElement('a');
				alink.href = fileURL;
				alink.download = 'Muhammad-Mubashir-AK-Resume.pdf';
				alink.click();
			});
		});
		setShow(false);
	};
	// const [change, setchange] = useState(false);
	// onscrollanimation start
	const anime1 = {
		visible: {
			opacity: 1,
			x: 0,
			transition: { ease: 'easeInOut', duration: 0.9 },
		},
		hidden: { opacity: 0, x: -100 },
	};
	const anime2 = {
		visible: {
			opacity: 1,
			x: 0,
			transition: { ease: 'easeInOut', duration: 0.9 },
		},
		hidden: { opacity: 0, x: 100 },
	};
	const anime3 = {
		visible: {
			opacity: 1,
			scale: 1,
			transition: { ease: 'easeInOut', duration: 1.8 },
		},
		hidden: { opacity: 0, scale: 0 },
	};

	const control = useAnimation();
	const [ref, inView] = useInView();
	useEffect(() => {
		if (inView) {
			control.start('visible');
		} else {
			control.start('hidden');
		}
	}, [control, inView]);
	// onscrollanimation end
	return (
		<>
			<motion.div className="col-lg-6 col-md-12 col-sm-12" ref={ref} variants={anime1} initial="hidden" animate={control}>
				<div className="inner-sec-name align-items-center">
					{/* <div className="mb-3 profile-img">
						<img src={ProfileImage} alt="ProfileImage" className="img-fluid" />
					</div> */}
					<motion.h1 className="name" ref={ref} variants={anime3} initial="hidden" animate={control}>
						MUHAMMED
						<br />
						MUBASHIR
					</motion.h1>
					{/* <h1>Web developer</h1>
					 */}
					<motion.button
						initial={{ opacity: 0.6 }}
						whileHover={{
							scale: 1.1,
							transition: { duration: 1 },
						}}
						whileTap={{ scale: 0.9 }}
						whileInView={{ opacity: 1 }}
						className="sec-btn btn align-items-center"
						onClick={resumebtn}>
						Download CV
						<span className="ms-2">
							<SlDocs />
						</span>
					</motion.button>
				</div>
			</motion.div>
			<motion.div className="col-lg-6 col-md-12 col-sm-12 text-center" ref={ref} variants={anime2} initial="hidden" animate={control}>
				<img src={avatar} alt="profile" className="sec-img-w-home" />
			</motion.div>
			<Modal show={show} centered>
				<Modal.Body>
					<h5 className="text-dark" style={{ fontWeight: '400' }}>
						To download the resume, simply click the "Confirm" button.
					</h5>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="danger"
						onClick={() => {
							setShow(false);
						}}>
						Cancel
					</Button>
					<Button variant="success" onClick={resumeDownload}>
						Confirm
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}

export default MainHome;
